import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const apiClient = {
  async post<T>(url: string, data?: any): Promise<T> {
    const response = await instance.post<T>(url, data);
    return response.data;
  },

  async get<T>(url: string, params?: any): Promise<T> {
    const response = await instance.get<T>(url, { params });
    return response.data;
  }
}; 